import React from "react";
import { useQuery } from "@apollo/client";
import { ActiveUserProjects, hash } from "../gql/ActiveUserProjects";
import {
  UserProjectsSubscription,
  hash as hash2,
} from "../gql/ActiveUserProjectsSubscription";
import ListGroup from "react-bootstrap/ListGroup";

const UserProjects = ({ userId, deselected, setDeselected, setCurrent }) => {
  const { data, loading, error, subscribeToMore } = useQuery(
    ActiveUserProjects,
    {
      variables: {
        userId: userId,
      },
      fetchPolicy: "network-only",
      nextFetchPolicy: "network-only",
      context: { headers: { "X-Trust-Key": hash } },
    }
  );

  subscribeToMore({
    document: UserProjectsSubscription,
    variables: {
      userId: userId,
    },
    updateQuery: (prev) => {
      return prev;
    },
    context: { headers: { "X-Trust-Key": hash2 } },
  });

  if (loading) return;

  if (error) return;

  if (data) {
    setCurrent(data?.allUserProjects?.nodes);
    return (
      <div style={{ width: "300px", border: "1px solid grey" }}>
        {data?.allUserProjects?.nodes?.length > 0 ? (
          <ListGroup variant="flush">
            {data.allUserProjects.nodes.map((projects) => (
              <ListGroup.Item
                action
                eventKey={projects.id}
                onClick={() => setDeselected(projects.id)}
              >
                {projects.projectName}
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <p
            className="row-sm-1 mb-0"
            style={{ textAlign: "center", color: "red" }}
          >
            Please assign projects.
          </p>
        )}
      </div>
    );
  }
};

export default UserProjects;
